import { render, staticRenderFns } from "./StudentEvaluationImport.vue?vue&type=template&id=07c33909&scoped=true"
import script from "./StudentEvaluationImport.vue?vue&type=script&lang=js"
export * from "./StudentEvaluationImport.vue?vue&type=script&lang=js"
import style0 from "./StudentEvaluationImport.vue?vue&type=style&index=0&id=07c33909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c33909",
  null
  
)

export default component.exports